function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, String, fromDateText, pickerMode, relativeOffsetValue, relativeWindowUnit, relativeWindowValue, showCustomControls, showEndingField, toDateText) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['custom-controls'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            elref: `customControlsContainer`
          }),
          "class": {
            'custom-controls': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((!$attr(`single-picker-mode`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-toggle", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `tab-bar`,
                selected: pickerMode,
                options: $helpers.getPickerModeToggleOptions(),
                elref: `pickerModeToggle`,
              }),
              "on": {
                select: $helpers.handleClickPickerMode,
              },
              "class": {
                'picker-modes': true
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined); /* set key=pickerMode to avoid snabbdom reuse which can cause issues in these control components when using props */ ;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "key": pickerMode,
            "class": {
              'text-controls': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((((pickerMode) == ($helpers.DatePickerMode.InTheLast))) ?
              ((function() {
                var __jade_nodes = [];
                const relativeOffset = $helpers.getSelectedOffset();;
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'control-wrapper': true,
                    'in-the-last': true,
                    'window': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-input", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'auto-focus': true,
                      type: `number`,
                      min: 0,
                      'select-on-focus': true,
                      placeholder: `Enter a value`,
                      'text-align': $helpers.TextAlign.Center,
                      elref: `relativeWindowInput`,
                    }),
                    "props": {
                      value: relativeWindowValue,
                    },
                    "on": {
                      input: $helpers.handleInTheLastWindowValueInput,
                      blur: $helpers.handleInTheLastWindowAndOffsetValueBlur,
                    },
                    "class": {
                      'relative-window': true
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'unit-select': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-select", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        theme: `select`,
                        'selected-option': $helpers.getTimeUnitLabel(relativeWindowUnit, $helpers.getSelectedWindowValue() || 2),
                        'menu-width': 0,
                        size: `large`,
                        sections: $helpers.getWindowUnitMenuSections(),
                        elref: `relativeWindowUnitSelect`,
                      }),
                      "on": {
                        change: $helpers.handleInTheLastWindowUnitChange,
                      },
                    }));
                    __jade_nodes = __jade_nodes.concat((relativeOffset && showEndingField) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", [__vjadeSafeCode(`Changing the unit from "days" will remove the ending date`)]));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(($helpers.canUseRolling()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'control-wrapper': true,
                      'in-the-last': true,
                      'ending': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat((showEndingField) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-input", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          type: `number`,
                          label: `Ending`,
                          min: 0,
                          'select-on-focus': true,
                          placeholder: `Enter a value`,
                          'text-align': $helpers.TextAlign.Center,
                          elref: `relativeOffsetInput`,
                        }),
                        "props": {
                          value: relativeOffsetValue,
                        },
                        "on": {
                          input: $helpers.handleInTheLastOffsetValueInput,
                          blur: $helpers.handleInTheLastWindowAndOffsetValueBlur,
                        },
                        "class": {
                          'relative-offset': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'label': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat($helpers.getTimeUnitLabel(relativeWindowUnit, relativeOffsetValue));
                        __jade_nodes = __jade_nodes.concat(` ago`);
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            icon: `circle-clear`,
                            theme: `tertiary`,
                          }),
                          "on": {
                            click: $helpers.handleHideEndingClick,
                          },
                          "class": {
                            'hide-ending': true
                          },
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)) : ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'show-ending': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            icon: `plus`,
                            theme: `tertiary`,
                            disabled: !relativeOffset,
                            elref: `showEndingButton`,
                          }),
                          "on": {
                            click: $helpers.handleShowEndingClick,
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("Ending");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat((!relativeOffset) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", [__vjadeSafeCode(`Change ${$helpers.getTimeUnitLabel(relativeWindowUnit, 2)} to days to select ending date`)]));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this)) :
              (((pickerMode) == ($helpers.DatePickerMode.Between)) || ((pickerMode) == ($helpers.DatePickerMode.On))) ?
              ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'control-wrapper': true,
                    'between': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-input", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'auto-focus': !fromDateText,
                      type: `text`,
                      placeholder: `Start date`,
                      elref: `betweenFromInput`,
                    }),
                    "props": {
                      value: fromDateText,
                    },
                    "on": {
                      input: $helpers.handleFromDateInput,
                      focus: () => $component.handleFromDateFocus(),
                      blur: () => $component.handleFromDateBlur(),
                      keydown: $helpers.handleFromDateArrowKeys,
                    },
                  }));
                  __jade_nodes = __jade_nodes.concat((pickerMode === $helpers.DatePickerMode.Between) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-input", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        type: `text`,
                        placeholder: `End date`,
                        elref: `betweenToInput`,
                      }),
                      "props": {
                        value: toDateText,
                      },
                      "on": {
                        input: $helpers.handleToDateInput,
                        focus: () => $component.handleToDateFocus(),
                        blur: () => $component.handleToDateBlur(),
                        keydown: $helpers.handleToDateArrowKeys,
                      },
                    }));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) :
              (((pickerMode) == ($helpers.DatePickerMode.Since))) ?
              ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'control-wrapper': true,
                    'since': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-input", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'auto-focus': !fromDateText,
                      type: `text`,
                      placeholder: `Since date`,
                      elref: `sinceFromInput`,
                    }),
                    "props": {
                      value: fromDateText,
                    },
                    "on": {
                      input: $helpers.handleFromDateInput,
                      focus: () => $component.handleFromDateFocus(),
                      blur: () => $component.handleFromDateBlur(),
                      keydown: $helpers.handleFromDateArrowKeys,
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) :
              undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          const shouldHideCalendarPreview = $helpers.shouldHideCalendarPreview();;
          const previewSelection = $helpers.getCalendarPreviewSelection();;
          const selection = previewSelection ? null : $helpers.getCalendarSelection();;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'calendar-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-scrolling-calendar", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'start-of-week': 0,
                /* TODO: hook up start-of-week with the user project's start of week */
                'today': $helpers.getTodayIso(),
                'disabled-until-date': $helpers.getMaximumDateIso(),
                'disabled-start-date': $helpers.getDisabledStartIso(),
                'selection': selection,
                'preview-selection': previewSelection,
                elref: `calendar`,
              }),
              "on": {
                dateclick: $helpers.handleCalendarDateClick,
                datemouseenter: $helpers.handleCalendarDateMouseEnter,
                datemouseleave: $helpers.handleCalendarDateMouseLeave,
              },
              "hook": {
                insert: $helpers.handleCalendarElementInsert,
                remove: $helpers.handleCalendarElementRemove,
              },
              "props": {
                dayTooltipRenderer: $helpers.renderCalendarDayTooltip
              },
              "class": Object.assign({}, {
                'is-hidden': shouldHideCalendarPreview
              }, {
                'calendar': true
              }),
            }));
            __jade_nodes = __jade_nodes.concat(($helpers.shouldShowUpsell()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-banner", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: $helpers.BannerTheme.Warn,
                  type: $helpers.BannerType.Embedded,
                  size: $helpers.BannerSize.ExtraSmall,
                  'body-text': `Upgrade your plan to query more than ${$attr(`max-history-days`)} days of data.`,
                }),
                "hook": {
                  insert: $helpers.handleUpsellBannerInsert,
                },
                "class": {
                  'upsell-banner': true
                },
              }));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'actions': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `tertiary`,
                elref: `cancelButton`,
              }),
              "on": {
                click: $helpers.handleCancelClick,
              },
              "class": {
                'clear': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Cancel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(($helpers.shouldShowUpsell()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: `/pricing`,
                  target: `_blank`,
                }),
                "on": {
                  click: $helpers.handleUpsellClick
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    icon: `share`,
                    theme: `tertiary`,
                    elref: `upsellButton`,
                  }),
                  "class": {
                    'apply': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Upgrade");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `tertiary`,
                  disabled: !$helpers.canApply(),
                  elref: `applyButton`,
                }),
                "on": {
                  click: $helpers.handleApplyClick,
                },
                "class": {
                  'apply': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Apply");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const presets = $helpers.getPresetMenuSections();;
    const hasPresets = presets[0].items.length > 0;;
    const showPresets = hasPresets && !$attr(`force-hide-preset-menu`);
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          expanded: showCustomControls,
          'no-presets': !showPresets,
        }, {
          'root': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((showPresets) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'side-bar': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                sections: presets,
                'unfocus-on-mouseleave': true,
                elref: `presetMenu`,
              }),
              "on": {
                clickItem: $helpers.handleClickPreset,
              },
              "class": {
                'presets': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
              "attrs": __vjadeStringifyAttrsIfObj({
                sections: [{
                  items: [{
                    isSelected: showCustomControls,
                    label: `Custom…`,
                  }]
                }],
                'unfocus-on-mouseleave': true,
                elref: `customMenu`,
              }),
              "on": {
                clickItem: $helpers.handleClickCustom,
              },
              "class": {
                'custom': true
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((showCustomControls) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['custom-controls'].call(this));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['custom-controls'].call(this));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "fromDateText" in locals ? locals.fromDateText : typeof fromDateText !== "undefined" ? fromDateText : undefined, "pickerMode" in locals ? locals.pickerMode : typeof pickerMode !== "undefined" ? pickerMode : undefined, "relativeOffsetValue" in locals ? locals.relativeOffsetValue : typeof relativeOffsetValue !== "undefined" ? relativeOffsetValue : undefined, "relativeWindowUnit" in locals ? locals.relativeWindowUnit : typeof relativeWindowUnit !== "undefined" ? relativeWindowUnit : undefined, "relativeWindowValue" in locals ? locals.relativeWindowValue : typeof relativeWindowValue !== "undefined" ? relativeWindowValue : undefined, "showCustomControls" in locals ? locals.showCustomControls : typeof showCustomControls !== "undefined" ? showCustomControls : undefined, "showEndingField" in locals ? locals.showEndingField : typeof showEndingField !== "undefined" ? showEndingField : undefined, "toDateText" in locals ? locals.toDateText : typeof toDateText !== "undefined" ? toDateText : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;